/** Window / document title for the active tab. */
export function formatWindowTitle(documentName: string, dirty: boolean): string {
  const name = documentName.trim() || "Untitled";
  return dirty ? `• ${name} — Curva` : `${name} — Curva`;
}
